// uses splide: https://splidejs.com/guides/getting-started/

import Splide from '@splidejs/splide';
import GLightbox from 'glightbox';

Drupal.behaviors.reGallery = {

  glightbox: null,


  // TODO: Es kann mehrere Gallerien auf der Seite geben, das Modal muss der richtigen Gallerie zugeordnet werden
  slider: null,
  slidermodal: null,
  splidethumb: null,

  attach() {
    this.glightbox = GLightbox();

    let sliders = document.querySelectorAll('.re-gallery');
    if (sliders.length) {
      for (var i = 0; i < sliders.length; i++) {
        let showArrows = true;
        let splideElement = sliders[i].querySelector('#splide-main');
        let slides = sliders[i].querySelectorAll('.splide__slide');

        if (slides.length <= 1) {
          showArrows = false;
        }

        const galleryButton = sliders[i].parentElement.querySelector('.js-gallery-open');
        // Slides that are no photo (financing CTA, virtual tour, IT-681): the gallery button
        // ("In Galerie öffnen") is hidden there, and the tour badge on the tour slide itself.
        const slideList = Array.from(slides);
        const noPhotoSlides = slideList
          .map((slide, index) => (slide.classList.contains('slide--cta') || slide.classList.contains('slide--tour') ? index : -1))
          .filter((index) => index !== -1);
        const tourSlideIndex = slideList.findIndex((slide) => slide.classList.contains('slide--tour'));
        const tourBadge = sliders[i].querySelector('.js-gallery-tour');
        let focusTourOnMove = false;

        const updateGalleryButton = (index) => {
          if (galleryButton && noPhotoSlides.length) {
            galleryButton.hidden = noPhotoSlides.includes(index);
          }
          if (tourBadge) {
            tourBadge.hidden = index === tourSlideIndex;
          }
        };

        const splideDefaultOptions = {
          type: 'slide',
          pagination: false,
          arrows: showArrows,
          cover: true,
          rewind: true,
          arrowPath: 'M4.354,41a2.754,2.754,0,0,1-1.947-4.7L15.865,22.84a2.6,2.6,0,0,0,0-3.676L2.406,5.7A2.754,2.754,0,1,1,6.3,1.807L19.76,15.269a8.107,8.107,0,0,1,0,11.465L6.3,40.193A2.745,2.745,0,0,1,4.354,41Z',
          i18n: {
            prev: 'Vorheriges Bild',
            next: 'Nächstes Bild',
            first: 'Zum ersten Bild',
            last: 'Zum letzten Bild',
          }
        };

        let splide = new Splide(splideElement, splideDefaultOptions);
        splide.on('mounted', () => updateGalleryButton(splide.index));
        splide.on('move', (newIndex) => updateGalleryButton(newIndex));
        splide.on('moved', (newIndex) => {
          // After the badge's jump the start button of the tour has the focus (Splide makes the
          // controls of hidden slides unfocusable until they are in view).
          if (focusTourOnMove && newIndex === tourSlideIndex) {
            const start = slides[tourSlideIndex].querySelector('.slide--tour__start');
            if (start) {
              start.focus({ preventScroll: true });
            }
          }
          focusTourOnMove = false;
        });
        splide.mount();

        if (tourBadge && tourSlideIndex !== -1) {
          tourBadge.addEventListener('click', () => {
            focusTourOnMove = true;
            splide.go(tourSlideIndex);
          });
        }

        this.slider = splide;

        sliders[i].classList.add('splide--processed');
      }

    }

  },


  goToSlide(nr) {
    setTimeout(() => {
      this.splidethumb.go(nr);

    }, 0);
  },

  openGallery() {
    this.glightbox.open();
  },
};


